import script from "./MaterialPickerDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialPickerDialog.vue?vue&type=script&setup=true&lang=js"

import "./MaterialPickerDialog.vue?vue&type=style&index=0&id=a09c3c18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a09c3c18"]])

export default __exports__